import { AdvisorSentiment } from "@types";

/**
 * The one place a backend sentiment becomes a colour. Callouts are supporting notes, so they
 * read quietly: a coloured left rule and a matching icon tint over neutral text — no fill. The
 * colour still carries the sentiment; it just doesn't shout.
 */
export const CALLOUT_STYLES: Record<
  AdvisorSentiment,
  { accent: string; icon: string }
> = {
  positive: { accent: "border-emerald-400", icon: "text-emerald-500" },
  // slate isn't in this Tailwind version's colour module at all (unlike emerald/amber/sky,
  // which just needed wiring up in tailwind.config.js) — gray is the equivalent already used
  // everywhere else in this feature.
  neutral: { accent: "border-gray-300", icon: "text-gray-400" },
  warning: { accent: "border-amber-400", icon: "text-amber-500" },
  critical: { accent: "border-red-400", icon: "text-red-500" },
  info: { accent: "border-sky-400", icon: "text-sky-500" },
};

/** Row tints are lighter — a table of coloured rows should stay readable. */
export const ROW_STYLES: Record<AdvisorSentiment, string> = {
  positive: "bg-emerald-50 bg-opacity-60",
  neutral: "",
  warning: "bg-amber-50 bg-opacity-60",
  critical: "bg-red-50 bg-opacity-60",
  info: "bg-sky-50 bg-opacity-50",
};
